import _extends from "@babel/runtime/helpers/esm/extends";
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { element, string, number, oneOfType, arrayOf, shape, node } from 'prop-types';
import Box from '../Box';
const defaultDelay = 500;
const defaultThreshold = 0;
const defaultRootMargin = '0px 0px 250px';

const LazyLoadComponent = ({
  children,
  options,
  layout
}) => {
  const {
    delay = defaultDelay,
    threshold = defaultThreshold,
    rootMargin = defaultRootMargin
  } = options || {};
  const [isVisible, setIsVisible] = useState(false);
  const [temporaryProps, addTemporaryProps] = useState(layout);
  const [elemRef, inView] = useInView({
    triggerOnce: true,
    threshold,
    rootMargin
  });
  useEffect(() => {
    let timer;

    if (inView && !isVisible) {
      setIsVisible(true);
      timer = setTimeout(() => addTemporaryProps({}), delay);
    }

    return () => timer && clearTimeout(timer);
  }, [inView]);
  return /*#__PURE__*/React.createElement(Box, _extends({}, temporaryProps, {
    "data-testid": "lazyload-container",
    ref: elemRef
  }), isVisible && children);
};

process.env.NODE_ENV !== "production" ? LazyLoadComponent.propTypes = {
  children: oneOfType([element, string, arrayOf(element), node]),
  layout: shape({}),
  options: shape({
    delay: number,
    rootMargin: string,
    threshold: number
  })
} : void 0;
LazyLoadComponent.defaultProps = {
  children: undefined,
  layout: {},
  options: {
    delay: defaultDelay,
    rootMargin: defaultRootMargin,
    threshold: defaultThreshold
  }
};
export default LazyLoadComponent;